import { StandardEvents } from '@shopify/events';

// Use the same settled cart events as the native theme, including removals.
let revision = 0;
const renderCount = (count) => {
  if (!Number.isInteger(count) || count < 0) return;
  document.querySelectorAll('[data-pc-cart]').forEach((link) => {
    const counter = link.querySelector('[data-pc-cart-count]');
    if (counter) counter.textContent = `(${count})`;
    link.setAttribute('aria-label', `Panier, ${count} article${count === 1 ? '' : 's'}`);
  });
};

async function refreshCount(currentRevision = ++revision) {
  const endpoint = document.querySelector('[data-pc-cart]')?.dataset.cartEndpoint;
  if (!endpoint) return;
  try {
    const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (currentRevision === revision) renderCount(cart.item_count);
  } catch {
    // Retain the server-rendered count when the connection is unavailable.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  const currentRevision = ++revision;
  try {
    const result = await event.promise;
    if (currentRevision !== revision) return;
    const count = result?.cart?.totalQuantity ?? result?.detail?.itemCount;
    if (Number.isInteger(count)) renderCount(count);
    else await refreshCount(currentRevision);
  } catch {
    // A failed update must not turn the counter into a false empty cart.
    if (currentRevision === revision) await refreshCount(currentRevision);
  }
});

window.addEventListener('pageshow', (event) => {
  if (event.persisted) refreshCount();
});
